.iconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--tuna-shape-radius-circle);
  cursor: pointer;
  padding: 8px;
  background-color: transparent;
  color: var(--tuna-palette-action-active);
  transition: background-color var(--tuna-transitions-duration-shortest) var(--tuna-transitions-easing-easeInOut);
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.iconButton:hover {
  background-color: var(--tuna-palette-action-hover);
}

.iconButton:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.iconButton:disabled {
  color: var(--tuna-palette-action-disabled);
  cursor: default;
  pointer-events: none;
}

.colorPrimary {
  color: var(--tuna-palette-primary-main);
}

.colorSecondary {
  color: var(--tuna-palette-secondary-main);
}

.colorError {
  color: var(--tuna-palette-error-main);
}

.colorInherit {
  color: inherit;
}

.sizeSmall {
  padding: 5px;
}

.sizeLarge {
  padding: 12px;
}

.edgeStart {
  margin-left: -12px;
}

.edgeEnd {
  margin-right: -12px;
}
